import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

const ZENDESK_AUTH = gql`
  query ZendeskAuth {
    ZendeskAuthentication {
      token
    }
  }
`;

const Zendesk = () => {
  const { t } = useTranslation();
  const { data, loading } = useQuery(ZENDESK_AUTH);
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('return_to') ?? undefined;

  if (loading) return <div>{t('zendesk.authenticating')}</div>;
  if (!data?.ZendeskAuthentication) return <div>{t('zendesk.authFailure')}</div>;

  return (
    <form
      action="https://hubert9080.zendesk.com/access/jwt"
      method="post"
      ref={(node) => node?.submit()}
      style={{ visibility: 'hidden' }}
    >
      <input type="hidden" name="jwt" value={data.ZendeskAuthentication.token}></input>
      <input type="hidden" name="return_to" value={returnTo}></input>
      <input type="submit" value={t('zendesk.submitButton')}></input>
    </form>
  );
};

export default Zendesk;
